// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RR73Y","minimap":"styles_minimap__xp02X","topPanel":"styles_topPanel__SBaZs","buttonText":"styles_buttonText__jkWei"};